/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import axios from 'axios';
import qs from 'qs';

import _ from 'lodash';

let options = {};

const API = {
  install(Vue, opts) {
    options = opts;
  },
};

function fixAxiosQueryParameters(queryParameters) {
  const keys = Object.keys(queryParameters);
  let queryUrl = null;

  if (keys.length > 0) {
    queryUrl = '?';

    for (let i = 0; i < keys.length; i++) {
      if (i > 0) queryUrl += '&';

      let parameter = queryParameters[keys[i]];
      if (_.isObject(parameter)) parameter = JSON.stringify(parameter);

      queryUrl += `${keys[i]}=${parameter}`;
    }
  }

  return queryUrl;
}

export default API;

export const AccessToken = {
  set(token) {
    axios.defaults.headers.common['Authorization'] = token;
  },
  clear() {
    axios.defaults.headers.common['Authorization'] = null;
  },
};

export const request = async (method, url, body, queryParameters, form, config) => {
  let queryUrl = url;
  let result = null;

  method = method.toLowerCase();

  // qs.stringify and loopback filters are natural enemies
  const fixedParams = fixAxiosQueryParameters(queryParameters);
  if (fixedParams) queryUrl += fixedParams;

  try {
    if (body) {
      result = await axios[method](queryUrl, body);
    } else if (method === 'get') {
      result = await axios[method](
        queryUrl,
        {
          params: form,
        },
        config
      );
    } else {
      result = await axios[method](queryUrl, qs.stringify(form));
    }
  } catch (error) {
    let errorMsg = null;

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      errorMsg = error.response.data;
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      errorMsg = error.request;
    } else {
      // Something happened in setting up the request that triggered an Error
      errorMsg = error.message;
    }

    throw errorMsg;
  }

  return result;
};

export const getOptions = function () {
  return options;
};

export const upload = async (url, file, fields) => {
  const formData = new FormData();
  formData.append('file', file);
  _.map(fields, (item, key) => formData.append(key, item));

  let result = null;
  try {
    result = await axios.post(getOptions().domain + url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  } catch (error) {
    let errorMsg = null;
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      errorMsg = error.response.data;
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      errorMsg = error.request;
    } else {
      // Something happened in setting up the request that triggered an Error
      errorMsg = error.message;
    }

    throw errorMsg;
  }

  return result;
};

export const download = (url, params) =>
  axios.get(getOptions().domain + url, {
    params,
  });
